import { createContext, useContext } from 'react';
export const FinanceContext = createContext({ unlocked: false, openPayments: () => {}, requestUnlock: () => {} });
export const useFinance = () => useContext(FinanceContext);
